import React from 'react';
import { View } from 'react-native';

import { FieldValue } from '../SettingsModal';
import { InfoIcon } from './Info';

import { getWarriorByLogin } from '../../lib/dbCalls';
import warriorInfoModalStore from '../common/WarriorInfoModal/store';
import { debounce } from 'lodash';
import { MARGIN_10, pOrT } from '../styleConstants';

type WarriorLoginFormProps = {
  item: { name: string; label: string; type: string };
  fields: any;
  setFields: (value: any) => void;
  selectedWarrior: any;
  setSelectedWarrior: (warrior: any) => void;
};

const WarriorLoginForm = ({
  item,
  fields,
  setFields,
  selectedWarrior,
  setSelectedWarrior,
}: WarriorLoginFormProps) => {
  return (
    <View key={item.name} style={{ marginBottom: MARGIN_10, flexDirection: 'row' }}>
      <FieldValue
        value={fields[item.name]}
        label={item.label.toUpperCase()}
        type={item.type as any}
        hint=""
        onChange={(value: any) => {
          setFields({
            ...fields,
            [item.name]: value,
          });

          if (item.name === 'login') {
            debounce(async () => {
              setFields((value: any) => {
                if (!value.login || (selectedWarrior && selectedWarrior.login === value.login))
                  return value;
                (async () => {
                  const warrior = await getWarriorByLogin(value.login);
                  setSelectedWarrior(warrior);
                })();
                return value;
              });
            }, 1000)();
          }
        }}
      />
      {item.name === 'login' && selectedWarrior ? (
        <InfoIcon
          style={{ position: 'absolute', right: -30, top: 20 }}
          iconStyle={{
            width: pOrT(16, 18),
            height: pOrT(16, 18),
          }}
          onPress={() => {
            warriorInfoModalStore.toggle(selectedWarrior.id, true);
          }}
        />
      ) : null}
    </View>
  );
};

export default WarriorLoginForm;
